















































































































































































import axios from 'axios'
import SIdentify from '@/components/identify.vue'
import {Vue, Component} from "vue-property-decorator";

@Component({components: {SIdentify}})
export default class login extends Vue {
    valideuserinfoPassword = (rule: any, value: string, callback: any) => {
        if (value !== this.userinfo.password) {
            callback(new Error("输入的密码不一致"))
        } else {
            callback()
        }
    };
    regExp_password = (rule: any, value: string, callback: any) => {
        let pPattern = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
        if (!pPattern.test(value)) {
            callback(new Error("至少1个大写字母，1个小写字母，1个数字"))
        } else {
            callback()
        }
    };
    $config: any;

    single = false;
    switchCode = false;
    sponsorship = false;
    register = false;
    userinfo = {
        username: '',
        password: '',
        confirmpassword: '',
        email: '',
        realname: '',
        department: ''
    };
    userinfoValidate = {
        username: [
            {
                required: true,
                message: "请输入用户名",
                trigger: 'blur'
            }
        ],
        password: [
            {
                required: true,
                message: "请输入密码",
                trigger: 'blur'
            },
            {
                min: 6,
                message: "请输入至少6个字符",
                trigger: 'blur'
            },
            {
                max: 32,
                message: "最多输入32个字符",
                trigger: 'blur'
            },
            {
                validator: this.regExp_password,
                trigger: 'blur'
            }
        ],
        confirmpassword: [
            {
                required: true,
                message: "请确认新密码",
                trigger: 'blur'
            },
            {
                validator: this.valideuserinfoPassword,
                trigger: 'blur'
            }
        ],
        realname: [
            {
                required: true,
                message: "请输入真实姓名",
                trigger: 'blur'
            }
        ],
        department: [
            {
                required: true,
                message: "请输入部门名",
                trigger: 'blur'
            }
        ],
        email: [
            {required: true, message: "请输入E-mail", trigger: 'blur'},
            {type: 'email', message: "E-mail格式错误", trigger: 'blur'}
        ]
    };
    formInline = {
        user: '',
        password: '',
        code: ''
    };
    check_code = '';

    checkCode(vl: string) {
        this.check_code = vl.toLowerCase()
    }

    LoginRegister() {
        let is_validate: any = this.$refs['userinfova'];
        is_validate.validate((valid: boolean) => {
            if (valid) {
                axios.post(this.$config.register, {
                    'userinfo': this.userinfo
                })
                    .then(res => {
                        this.$config.notice(res.data);
                        this.$config.clearObj(this.userinfo)
                    })
                    .catch(error => {
                        this.$config.err_notice(this, error)
                    })
            } else {
                this.$config.err_notice("请正确填写相关注册信息")
            }
        })
    }

    signIn() {
        if (this.check_code !== this.formInline.code.toLowerCase()) {
            this.$Message.warning({
                content: '验证码错误，请重新输入！'
            });
            return
        }
        let url = this.$config.auth;
        if (this.single) {
            url = `${this.$config.gen}/ldap`
        }
        axios.post(url, {
            'username': this.formInline.user,
            'password': this.formInline.password
        })
            .then(res => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token;
                sessionStorage.setItem('user', this.formInline.user);
                sessionStorage.setItem('jwt', `Bearer ${res.data.token}`);
                sessionStorage.setItem('auth', res.data['permissions']);
                sessionStorage.setItem('real_name', res.data['real_name']);
                let auth = res.data['permissions'];
                (auth === 'admin' || auth === 'perform') ? sessionStorage.setItem('access', '0') : sessionStorage.setItem('access', '1');
                this.$router.push({
                    name: 'home_index'
                })
            })
            .catch(err => {
                this.$config.auth_notice(err)
            })
    }

    mounted() {
        let windows: any = window;
        windows.particlesJS.load('band', `${process.env.BASE_URL}particlesjs-config.json`);
        axios.get(`${this.$config.gen}/fetch`)
            .then(res => {
                if (res.data === 1) {
                    this.switchCode = true;
                }
            })
            .catch(err => this.$config.auth_notice(err));
    }
}
